import { FC, useState } from "react";
import { Grid, Pagination as PaginationImpl, Form, Button, Icon, Input } from "semantic-ui-react";

interface PaginationProps {
    activePage: number;
    totalPages: number;
    onPageChange(newPage: number): void;
}


export const Pagination: FC<PaginationProps> = ({ onPageChange: changePage, totalPages, ...rest }) => {
    const [goPage, setGoPage] = useState("");

    const goToPage = (e: any) => {
        if (goPage !== "") {
            changePage(parseInt(goPage));
        }
    };

    const changeGoPage = (e: any) => {
        let newValue = e.target.value.replace(/\D/g, "");
        if (newValue !== "") {
            newValue = parseInt(newValue);
            newValue = Math.min(Math.max(1, newValue), totalPages);
        }
        setGoPage(newValue);
    };

    return (
        <Grid columns={3}>
            <Grid.Column style={{ width: '100%' }} textAlign='center'>

                <Form onSubmit={() => {}}>
                    <Form.Field inline>
                        <PaginationImpl
                            totalPages={totalPages}
                            {...rest}
                            onPageChange={(_, { activePage }) => {
                                switch (typeof activePage) {
                                    case 'number':
                                        changePage(activePage);
                                        break;
                                    case 'string':
                                        changePage(parseInt(activePage));
                                }
                            }}
                        />

                        <Input
                            value={goPage}
                            style={{width: 80}} placeholder='Page'
                            action={{ icon: "angle double right", onClick: goToPage }}
                            onChange={changeGoPage}
                        />
                    </Form.Field>
                </Form>
            </Grid.Column>
        </Grid>
    );
};

export default Pagination;
